import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiTableModule } from 'omnium-ui/table';
import { OuiTagModule } from 'omnium-ui/tag';
import { appRoutePaths } from '../../../../../../app.paths';
import { ConsultantCardComponent } from '../../../../../../core/components/consultant-card/consultant-card.component';
import {
  DuplicateInvestorGroupAnalysis,
  InvestorInspectionMetadata,
  ProblematicMetadataRow
} from '../../../../../../core/models/api.models';
import {
  getMetadataBadgeLabel,
  getMetadataBadgeStatus
} from '../../../../shared/metadata-inspection.utils';
import { formatAtlasPersonnePhysiqueIds } from '../../../../shared/atlas-inspection.utils';
import { InvestorDetailsComponent } from '../../../../shared/investor-details/investor-details.component';
import { InvestorStatusTagComponent } from '../../../../shared/investor-status-tag/investor-status-tag.component';
import { StateCardComponent } from '../../../../shared/state-card/state-card.component';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-minotaure-section',
  imports: [
    MatTableModule,
    OuiButtonModule,
    OuiTableModule,
    OuiTagModule,
    ConsultantCardComponent,
    InvestorDetailsComponent,
    InvestorStatusTagComponent,
    StateCardComponent,
    InvestorViewerAccordionComponent
  ],
  templateUrl: './investor-minotaure-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../investor-viewer-section.shared.scss',
    './investor-minotaure-section.component.scss'
  ]
})
export class InvestorMinotaureSectionComponent {
  readonly investorId = input.required<number>();
  readonly corrections = input.required<ProblematicMetadataRow[]>();
  readonly anomalies = input.required<ProblematicMetadataRow[]>();
  readonly metadatas = input.required<InvestorInspectionMetadata[]>();
  readonly loading = input(false);
  readonly error = input<string | null>(null);

  protected readonly metadataColumns = ['investor', 'consultant', 'status', 'arianeId'];
  protected readonly problemColumns = ['metadataId', 'detection', 'details', 'actions'];
  protected readonly getMetadataBadgeStatus = getMetadataBadgeStatus;

  constructor(private readonly router: Router) {}

  protected openMetadata(metadataId: number): void {
    this.router.navigateByUrl(appRoutePaths.minotaure.metadata(metadataId));
  }

  protected getMetadataInvestorRow(
    metadata: InvestorInspectionMetadata
  ): ProblematicMetadataRow | undefined {
    return metadata.workspace.rows.find(row => row.investorId === this.investorId());
  }

  protected getDuplicateGroup(
    metadata: InvestorInspectionMetadata
  ): DuplicateInvestorGroupAnalysis | undefined {
    return metadata.workspace.duplicateAnalysis.duplicateGroups.find(group =>
      group.investors.some(investor => investor.investorId === this.investorId()));
  }

  protected getMetadataBadgeLabel(metadata: InvestorInspectionMetadata): string {
    return getMetadataBadgeLabel(metadata, 'Doublon traité');
  }

  protected formatPersonnePhysiqueIds(ids: number[]): string {
    return formatAtlasPersonnePhysiqueIds(ids);
  }
}
